import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { BREAK_TYPE_ENUM } from '../../../../constants/lookup/common/break-type.enum';
import { TimesheetEnum } from '../../../../constants/lookup/timesheet/timesheet-status.enum';
import { ShiftBreakActualDetailsComponent } from '../../../../modules/main/shift-info/components/shift-break-actual-details/shift-break-actual-details.component';
import { CountType } from '../../../../modules/main/shift-info/pages/shift-info-main/shift-info-main.constant';
import { ModalBaseClass } from '../modals/base_class/modal-base-class';

@Component({
  standalone: false,
  selector: 'kt-shift-control-actual-info',
  templateUrl: './shift-control-actual-info.component.html',
  styleUrls: ['./shift-control-actual-info.component.scss'],
})
export class ShiftControlActualInfoComponent extends ModalBaseClass implements OnInit {
  @Input() scheduleShiftDetails = null;
  @Input() actualShiftDetails = null;
  @Input() shiftAllInfo = null;
  @Output() eHide: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() eOpenModal = new EventEmitter<any>();
  @Output() eStartShift = new EventEmitter<any>();

  ngOnInit() {

  }

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
  ) {
    super(modalService);
  }

  hideClickHandler() {
    this.eHide.emit(true);
  }

  openModalHandler(modal) {
    this.eOpenModal.emit(modal);
  }

  startShiftClickHandler() {
    this.eStartShift.emit(true);
    this.activeModal.close();
  }
}
